let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ctZCD"), load("f7nCb")]).then(() => parcelRequire('4xvKn'));